import type { MailboxInfo } from 'owa-client-types';
import type { LicensingMailboxInfo } from 'owa-account-source-list-types';
import type { CoprincipalAccountSource } from '../store/schema/AccountSourceList';

export function getEasidLicensingMailboxInfo(
    account: CoprincipalAccountSource | undefined
): LicensingMailboxInfo | undefined {
    return account?.licensingMailboxInfo;
}

export function getLinkedMsaMailboxInfo(
    account: CoprincipalAccountSource | undefined
): MailboxInfo | undefined {
    return account?.msaLinkedMailbox;
}
